import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=58c5debd&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./../../../../../assets/mobileStyle.css?vue&type=style&index=0&id=58c5debd&prod&scoped=true&lang=css&"
import style1 from "./Edit.vue?vue&type=style&index=1&id=58c5debd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c5debd",
  null
  
)

export default component.exports